import { render, staticRenderFns } from "./LibraryDataset.vue?vue&type=template&id=bbda04a0"
import script from "./LibraryDataset.vue?vue&type=script&lang=js"
export * from "./LibraryDataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports